<script lang="ts" setup>
const isShowSplitModal = defineModel('isShowSplitModal', { default: false });
const { amount } = defineProps<{ amount: number; withShadow?: boolean }>();

const { yandexPayMerchantId } = useRuntimeConfig().public;
const { yandexSplitThreshold } = storeToRefs(useSiteStore());
const widgetContainer = ref<HTMLElement | null>(null);
const isModalOpened = ref(false);
const { isLoading: isShowSpinner } = useYandexPayWidget({
  target: () => widgetContainer.value,
  amount: () => amount,
  enabled: () => isShowSplitModal.value && isModalOpened.value,
  widgetType: 'BnplPreview',
});

watch(isShowSplitModal, (isOpen) => {
  if (!isOpen) isModalOpened.value = false;
});
</script>

<template>
  <div v-show="amount && yandexSplitThreshold && amount >= yandexSplitThreshold">
    <button
      class="w-full"
      @click="isShowSplitModal = true"
    >
      <div
        :class="{ 'shadow-md': withShadow }"
        class="yandex-pay-badge"
      >
        <yandex-pay-badge
          :amount
          :merchant-id="yandexPayMerchantId"
          align="center"
          color="primary"
          size="M"
          type="bnpl"
          variant="detailed"
        />
      </div>
    </button>

    <BaseModal
      v-model="isShowSplitModal"
      @close="isShowSplitModal = false"
      @opened="isModalOpened = true"
    >
      <div
        ref="widgetContainer"
        class="relative min-h-72"
      >
        <Transition name="loader">
          <div
            v-if="isShowSpinner"
            class="absolute z-10 flex items-center justify-center h-full w-full bg-white opacity-70"
          >
            <SvgoSpinner
              :font-controlled="false"
              class="size-14 animate-spin"
              filled
              title="Идет загрузка..."
            />
          </div>
        </Transition>
      </div>

      <slot />
    </BaseModal>
  </div>
</template>

<style lang="scss">
.yandex-pay-badge {
  display: flex;
  justify-content: center;
  padding: 16px;
  border: 1px solid $black-10;
  border-radius: 12px;
  background-color: $white;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
  }
}

@include screen-sm {
  .base-modal__content {
    min-width: 600px;
  }
}
</style>
